import { Box, Tooltip } from '@mui/material'

import type React from 'react'

interface DisabledReasonTooltipProps {
  reason?: string
  children: React.ReactElement
}

// Disabled elements don't fire the events MUI's Tooltip listens on, so the reason variant
// needs a span wrapper; without a reason the child is returned untouched, DOM-identical.
// The child stops catching the pointer so the wrapper's not-allowed cursor shows over it.
export function DisabledReasonTooltip({ reason, children }: DisabledReasonTooltipProps) {
  if (!reason) return children
  return (
    <Tooltip title={reason} placement="left">
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          minWidth: 0,
          cursor: 'not-allowed',
          '& > *': { pointerEvents: 'none' },
        }}>
        {children}
      </Box>
    </Tooltip>
  )
}
